import { useSuspenseQuery, type UseSuspenseQueryResult } from '@tanstack/react-query';

import { type OffersGroupedProps } from '../../contract';
import { fetchOffersGroupedData, getOffersGroupedCacheKey } from '../api/offers-delivery-api.service';
import { type OffersGroupedResponseData } from '../interfaces/offers.interface';

const normaliseOffersGroupedData = (data: OffersGroupedResponseData | null) => {
  if (!data) return data;

  return data.map(item => {
    if ('code' in item.bookmaker && typeof item.bookmaker.code === 'string') {
      item.bookmaker.feedsCode = item.bookmaker.code;
      delete item.bookmaker.code;
    }

    if ('clickoutUrl' in item && typeof item.clickoutUrl?.url === 'string') {
      item.clickOutUrl = item.clickoutUrl?.url;
      delete item.clickoutUrl;
    }

    if ('isTermsExpanded' in item && typeof item.isTermsExpanded === 'boolean') {
      item.autoExpandedTermsAndConditions = item.isTermsExpanded;
      delete item.isTermsExpanded;
    }

    return item;
  });
};

export const useQuery = ({
  dataApiEndpoint,
  ...queryArgs
}: OffersGroupedProps): UseSuspenseQueryResult<OffersGroupedResponseData | null> => {
  return useSuspenseQuery<OffersGroupedResponseData | null>({
    queryFn: () =>
      fetchOffersGroupedData(dataApiEndpoint, queryArgs, {
        logger: console,
      }),
    queryKey: getOffersGroupedCacheKey(queryArgs),
    select: data => {
      return normaliseOffersGroupedData(data);
    },
  });
};
